import { render, staticRenderFns } from "./ContactRow.vue?vue&type=template&id=e28f9b0e"
import script from "./ContactRow.vue?vue&type=script&lang=js"
export * from "./ContactRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports